const { env } = require('./prod.env');

export const CONFIG = env;
CDATASection.apply;
CDATASection;
